import React, { useEffect, useState } from "react";
import "./whatsapp.css";

export default function WhatsAppButton() {
  const [stopAt, setStopAt] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const footer = document.querySelector("footer");
      if (!footer) return;

      const footerRect = footer.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      // If bottom of screen is touching footer, stop floating
      setStopAt(footerRect.top <= windowHeight - 80);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // run once on mount

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <a
      href="https://wa.me/message/SZYNAQ7KQMY3K1"
      target="_blank"
      rel="noopener noreferrer"
      className={`whatsapp-float ${stopAt ? "static" : ""}`}
    >
      <img
        src="/icons/whatsapp.png"
        alt="WhatsApp"
        className="whatsapp-icon"
      />
    </a>
  );
}
